import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
//action
import * as actions from "Store/Course/Instructor/OtherLabs/Actions";
import "../../css/Options.scss";
import log from "loglevel";

// Helper function to strip letter prefixes like "A. ", "B. ", etc.
const stripPrefix = (text) => {
  return text.replace(/^[A-Z]\.\s*/, '');
};

const Option = ({
  courseId,
  question,
  otherLabID,
  questionId,
  option,
  optionIndex,
  questionType,
  previousResponse,
  setQRId,
  qrId,
  updateResponse,
  disable,
  Eval
}) => {

  const { id, text } = option; // Option ID and Option Text
  // const [check, setCheck] = useState(previousResponse.response_options ? previousResponse.response_options.find(item => item.id === id) : false);
  const [check, setCheck] = useState((previousResponse?.response_options_ids?.includes(id)) || false);
  //const [check,setCheck]=useState(false)

  // log.log(id, check, previousResponse.response_options_ids, "checkk");
  // log.log(previousResponse.response_options_ids?.includes(id), id, "checkk extra");

  useEffect(() => {
    // log.log("check:", check);
  }, [check]);

  useEffect(() => {
    // log.log("response_options_ids:", previousResponse.response_options_ids);
    setCheck((previousResponse?.response_options_ids?.includes(id) || false))
  }, [previousResponse.response_options_ids]);

  const answerOptions = question.questionanswer_set?.map(answer => answer.answer_option);

  useEffect(() => {
    // log.log({ qrId });
  }, [qrId]);

  const storeResponses = (event, id) => {
    // Per-option API call removed — local state only. Autosave runs every
    // 30s in student/index.jsx and on Submit Quiz, batching all 20 answers
    // into one POST .../student_submission/?autosave=true.
    if (disable) return;
    event?.stopPropagation();

    let updatedResponseOptions = [];
    let updatedResponseOptionsIds = [];

    if (questionType === "S") {
      // Single choice: replace selection with this option only
      updatedResponseOptions = [id];
      updatedResponseOptionsIds = [id];
    } else if (questionType === "M") {
      // Multi choice: toggle this option in/out of the existing selection
      setCheck(!check);
      const prevIds = previousResponse?.response_options_ids ?? [];
      if (prevIds.includes(id)) {
        updatedResponseOptionsIds = prevIds.filter((itemId) => itemId !== id);
        updatedResponseOptions = (previousResponse?.response_options ?? []).filter(
          (item) => (item?.id ?? item) !== id
        );
      } else {
        updatedResponseOptionsIds = [...prevIds, id];
        updatedResponseOptions = [...(previousResponse?.response_options ?? []), { id }];
      }
    }

    // Ensure updatedResp has the same structure as the first previousResponse
    const updatedResp = {
      ...previousResponse,
      response_options: updatedResponseOptions,
      response_options_ids: updatedResponseOptionsIds,
      id: question?.id,
    };

    updateResponse(updatedResp);
  };




  const isOptionCorrect = answerOptions.includes(id);
  const isOptionSelected = previousResponse?.response_options_ids?.includes(id);
  // log.log(previousResponse.response_option_ids, " now", isOptionCorrect, isOptionSelected);
  switch (questionType) {
    case "S":
      return (
        <Col xs={12}
          className={`option ${disable ? "disabled" : ""}`} style={Eval ? { border: isOptionCorrect ? '2px solid green' : (isOptionSelected ? '2px solid red' : ''), backgroundColor: isOptionCorrect ? '#a5f1d9' : (isOptionSelected ? '' : '') } : {}}
          onClick={(e) => !disable && storeResponses(e, id)}
        >
          <Form.Check
            type="radio"
            id={id}
            label={`${String.fromCharCode(65 + optionIndex)}. ${stripPrefix(text)}`}
            name={questionId}
            // defaultChecked={check}
            checked={isOptionSelected}
            disabled={disable}
          />
          {/* {log.log(id, check, "mcq", questionId)} */}
        </Col>
      );
    case "M":
      return (
        <Col xs={12} className={`option ${disable ? "disabled" : ""}`} style={Eval ? { border: isOptionCorrect ? '2px solid green' : (isOptionSelected ? '2px solid red' : ''), backgroundColor: isOptionCorrect ? '#b9eddd' : (isOptionSelected ? '' : '') } : {}} onClick={(e) => !disable && storeResponses(e, id)}>
          <Form.Check
            type="checkbox"
            id={id}
            label={`${String.fromCharCode(65 + optionIndex)}. ${stripPrefix(text)}`}
            name={questionId}
            //defaultChecked={check}
            checked={isOptionSelected}
            // checked={previousResponse.response_options ? previousResponse.response_options.find(item => item.id === id) : false}
            disabled={disable}
          />
        </Col>
      );
    default:
      return (
        <Row>
          <div>Question Option issue</div>
        </Row>
      );
  }
};

const Options = ({
  courseId,
  question,
  otherLabID,
  questionId,
  options,
  questionType,
  previousResponse,
  updateResponse,
  disable,
  Eval
}) => {

  const [questionResponseId, setQuestionResponseId] = useState(null);

  useEffect(() => {
    // log.log("previous Response is", { qrId: previousResponse })
    if (previousResponse && !questionResponseId) {
      setQuestionResponseId(previousResponse.id)
    }
  }, [previousResponse]);

  const handleUpdateResponse = (updatedOptions) => {
    // Update the previousResponse object with the updated optionsresponse_options_ids: updatedResponseOptionsIds
    //const updatedresponse = { ...previousResponse, response_options: updatedOptions };
    // log.log(" here --- > ", {qrId: updatedOptions})
    updateResponse(updatedOptions);
  };

  return (
    <Row className="options">
      {options.map((option, index) => (
        <Option
          courseId={courseId}
          question={question}
          otherLabId={otherLabID}
          questionId={questionId}
          option={option}
          optionIndex={index}
          questionType={questionType}
          previousResponse={previousResponse}
          qrId={questionResponseId}
          setQRId={(id) => setQuestionResponseId(id)}
          // updateResponse={updateResponse}
          updateResponse={handleUpdateResponse}
          disable={disable}
          Eval={Eval}
        />
      ))}
    </Row>
  );
};

export default Options;
